import { TColor } from "@eworkit/iris/dist/components/Colors/config";

export type TColorVariant =
  | TColor
  | "inherit"
  | "primary"
  | "default"
  | "white"
  | "link"
  | "background-main"
  | "background-card"
  | "background-card-bottom"
  | "black"
  | "grey1"
  | "grey2"
  | "grey3"
  | "grey4"
  | "grey5"
  | "grey6"
  | "border-inside"
  | "error"
  | "warning"
  | "success"
  | "info"
  | "dark-cyan"
  | "border-dashed"
  | "light-green"
  | "dark-green";

export const buildBackgroundColorVariantClassNames = (colorVariant: TColorVariant) =>
  `-background-color-variant-${colorVariant}`;

export const buildTextColorVariantClassNames = (colorVariant: TColorVariant) => `-text-color-variant-${colorVariant}`;

export const buildBorderColorVariantClassNames = (colorVariant: TColorVariant) =>
  `-border-color-variant-${colorVariant}`;
